import Styles from "./Styles/Filtering.module.css";

const Filtering = ({
  activeFilter,
  handleFiltering,
  filterKind,
  filterName,
  darkIcon,
  whiteIcon,
}) => {
  return (
    <>
      <div
        onClick={() => handleFiltering(filterKind)}
        className={`${Styles.filterContainer} ${
          activeFilter.includes(filterKind) ? Styles.activeFilter : {}
        }`}
      >
        <h3>{filterName}</h3>
        <img
          src={activeFilter.includes(filterKind) ? darkIcon : whiteIcon}
          alt=""
        />
      </div>
    </>
  );
};

export default Filtering;
